'use strict';
module.exports = require('../../full/object/assign');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/features/object/assign.js
// module id = 350
// module chunks = 0